export default "__VITE_ASSET__Du5um3zO__"